import {
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";

import { AccountService } from "../core/service/account.service";
import { Observable, throwError } from "rxjs";
import { catchError, retry, finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import {
  environment,
  httpInterceptorEnvironment,
} from "../../environments/environment";

import { Router } from "@angular/router";


//errors caseHandler
import { CaseHandler } from "./case-handler";
import { AuthenticationService } from "../core/service/authentication.service";
import { ToastrService } from "ngx-toastr";
import { DataDogLoggerService } from "../core/datadog-logger.service";
import { HttpErrorHandlerService } from "../core/service/http-error-handler.service";
import { MockServerService } from "../shared/mock-server.service";

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  caseHandler = new CaseHandler();
  private isBatchBusy: boolean = false;

  latestMockStatus: boolean = false;
  constructor(
    private accountService: AccountService,
    //  private loadingDialogService: LoadingDialogService,
    private router: Router,
    private logger: DataDogLoggerService,
    private toastr: ToastrService,
    private auth: AuthenticationService,
    private httpErrorHandler: HttpErrorHandlerService,
    private mockServerService: MockServerService
  ) {

    this.auth.serverStatsBanner$.subscribe((response: any) => {
      if (response && response.RevBatchRunning && response.RevBatchRunning.status === "1") {
        this.isBatchBusy = true;
      } else {
        this.isBatchBusy = false;
      }
    });
 // Subscribe ONCE to keep track of latest mock status
 this.mockServerService.mockServerStatus$.subscribe((status) => {
  this.latestMockStatus = status;
});

  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

 // Clone the request and add the new headers
 const headers: any = {
  MOCK_SERVER_STATUS: this.latestMockStatus  ? 'true' : 'false',
  appName: environment.appName,
  REVENUED_MIDDLEWARE_TOKEN: environment.REVENUED_MIDDLEWARE_TOKEN
};

function extractPathAndQuery(fullUrl: string): string {
  try {
    const urlObj = new URL(fullUrl);
    return urlObj.pathname + urlObj.search;
  } catch {
    return fullUrl;
  }
}

function wildcardMatch(input: string, pattern: string): boolean {
  const [inputPath] = input.split('?');
  const [patternPath] = pattern.split('?');

  // Match path only
  const pathRegex = new RegExp(
    '^' + patternPath.replace(/\*/g, '[^/?&=]+') + '$'
  );
  return pathRegex.test(inputPath);
}

function normalizeStoredUrl(storedUrl: string): string {
  const [path, query] = storedUrl.split('?');
  const pathParts = path.split('/').filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const isDynamicId = /^00[0-9a-zA-Z]+$/.test(lastSegment);

  if (isDynamicId) {
    pathParts[pathParts.length - 1] = '*';
  }
  const normalizedPath = '/' + pathParts.join('/');
  let normalizedQuery = '';
  if (query) {
    const params = query.split('&').map((pair) => {
      const [key] = pair.split('=');
      return `${key}=*`;
    });
    normalizedQuery = '?' + params.join('&');
  }
  return normalizedPath + normalizedQuery;
}


if (this.latestMockStatus) {
  const adminWidgetSettings = localStorage.getItem('adminWidgetSettings');
  if (adminWidgetSettings) {
    try {
      const settings = JSON.parse(adminWidgetSettings);
      const requestMethod = request.method.toUpperCase();
      const requestPath = extractPathAndQuery(request.url); 

      const settingsArray = Array.isArray(settings) ? settings : [settings];

      const matchingSetting = settingsArray.find(setting => {
        if (setting.endpoint && setting.case) {
          const [storedMethod, ...storedUrlParts] = setting.endpoint.split(' ');
          const storedUrl = storedUrlParts.join(' ').trim();
          const normalizedStoredUrl = normalizeStoredUrl(storedUrl);
          const isMatch = wildcardMatch(requestPath, normalizedStoredUrl);
          return (requestMethod === storedMethod && isMatch);
        }
        return false;
      });

      if (matchingSetting) {
        headers['cases'] = matchingSetting.case;
      }
    } catch (error) {
      console.error(error);
    }
  }
}


// // Add the Authorization header only if the token exists
// const token = JSON.parse(localStorage.getItem("token")||"");
// if (token?.access_token) {
//   headers.Authorization = `Bearer ${token?.access_token}`;
// }
    // Clone the request and add the new headers

// Add revenued_is_batch_busy header if batch is running
if (this.isBatchBusy) {
  headers['revenued_is_batch_busy'] = "1";
}

// // Add the Authorization header only if the token exists
// const token = JSON.parse(localStorage.getItem("token")||"");
// if (token?.access_token) {
//   headers.Authorization = `Bearer ${token?.access_token}`;
// }

    const modifiedRequest = request.clone({ setHeaders: headers });
    //global interceptor error handler
    //no redirect on 401
    let noRedirect = ['verify2FAChallenge', 'clientAccessToken', 'revenuedIsBatchBusy']
    return next.handle(modifiedRequest).pipe(
      retry(httpInterceptorEnvironment.errorHandlerRetryAttemt),
      catchError((error) => {
        // Handle special status codes using the error handler service
        if (this.httpErrorHandler.handleHttpError(error)) {
          return throwError(error);
        }

        // Handle 401 errors with special logic for noRedirect URLs
        if (error.status === 401 && !noRedirect.some(url => error.url?.includes(url))) {
          // window.localStorage.clear();
          this.auth.clearSafeLocalStorage();
          let idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
          if (idToken) { //if user logged in and unauthorized then only give warning.
            this.toastr.warning("Unauthorized!");
          }
          this.router.navigate(['/login']);
        }

        const ENABLE_GLOBAL_HTTP_INTERCEPTOR = window.localStorage.getItem('ENABLE_GLOBAL_HTTP_INTERCEPTOR');
        //get errorType & textMessage for logger
        let result: any = this.caseHandler.getErrors(error);
        console.log(error)
        //the global error handler runs if environments varaibles wishes not to bypass
        if (ENABLE_GLOBAL_HTTP_INTERCEPTOR === "true") {

          //here we are parsing the request headers to see if the skip_interceptor is present or not
          if (!request.headers.get("skip_interceptor")) {
            //logging the error level and message into dataDog
            this.logger.logDataDogEvent("error", result.errorType + " :  " + result.textMessage, 'httpInterceptor')
              .subscribe(() => { });
            // logging the error type and title into logDNA
            this.accountService
              .logEvent({
                logLevel: "error",
                message: {
                  title: result.errorType + " :  " + result.textMessage,
                  oppId: localStorage.getItem("oppId"),
                  cardId: localStorage.getItem("cardId"),
                  drawAmount: 0,
                },
              })
              .subscribe(() => { });
            // redirect to error page with relavant error code to display

            if (error.status === 401) {
              this.toastr.warning("Session expired, please login again!");
              this.router.navigate(["/login"]).then((res) => {
                // localStorage.clear();
                this.auth.clearSafeLocalStorage();
              });
            } else if (error.hasOwnProperty('status')) {
              this.router.navigate(["/error", result?.status ? result?.status : '']);
            } else {
              this.router.navigate(["/error"]);
            }
          } else {
            console.log("AY AY CAPTAIN! SKIPPING INTERCEPTOR. - BY HEADER");
          }

          if (!request.headers.get("skip_interceptor_rum_logs")) {
            try {
              //create rum action to make it searchable in sessions&replay
              this.auth.RumLoggerObj$.setCustomAction('Error - ' + result.errorType + " :  " + result.textMessage + " " + 'httpInterceptor', {
                "url": request?.url,
                "req": request,
                "res": error,
                "log": result
              });

            } catch (error) {
              //do nothing
            }
          }
        } else {
          console.log("AY AY CAPTAIN! SKIPPING INTERCEPTOR. - BY ENV VARIABLE");
        }


        return throwError(error);
      }),
      finalize(() => {
        //   this.loadingDialogService.hideDialog();
      })
    ) as Observable<HttpEvent<any>>;
  }
}
